import type {
  CreateRbacRoleRequest,
  RbacRole,
  ReplaceRbacAdminRoleAssignmentsRequest,
  ReplaceRbacRoleAdminsRequest,
  ReplaceRbacRoleAssignmentsRequest,
  ReplaceRbacRolePermissionsRequest,
  ReplaceRbacV2RolePermissionsRequest,
  UpdateRbacRoleRequest,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const createRbacRole = async (data: CreateRbacRoleRequest) => {
  const response = await gozokiApiWithAuth.post<RbacRole>('/rbac/roles', data)
  return response.data
}

export const updateRbacRole = async ({
  roleId,
  data,
}: {
  roleId: number
  data: UpdateRbacRoleRequest
}) => {
  const response = await gozokiApiWithAuth.patch<RbacRole>(`/rbac/roles/${roleId}`, data)
  return response.data
}

export const replaceRbacRolePermissions = async ({
  roleId,
  data,
}: {
  roleId: number
  data: ReplaceRbacRolePermissionsRequest
}) => {
  const response = await gozokiApiWithAuth.put<RbacRole>(`/rbac/roles/${roleId}/permissions`, data)
  return response.data
}

export const replaceRbacRoleV2Permissions = async ({
  roleId,
  data,
}: {
  roleId: number
  data: ReplaceRbacV2RolePermissionsRequest
}) => {
  const response = await gozokiApiWithAuth.put<RbacRole>(
    `/rbac/roles/${roleId}/permissions-v2`,
    data,
  )
  return response.data
}

/**
 * @deprecated Modèle canonique : une affectation porte son périmètre boutique. Utiliser
 * `replaceRbacRoleAssignments`. L'API accepte encore `{ adminIds }` transitoirement.
 */
export const replaceRbacRoleAdmins = async ({
  roleId,
  data,
}: {
  roleId: number
  data: ReplaceRbacRoleAdminsRequest
}) => {
  const response = await gozokiApiWithAuth.put<RbacRole>(`/rbac/roles/${roleId}/admins`, data)
  return response.data
}

/**
 * Remplacement complet des affectations d'un rôle, périmètre boutique compris
 * (`allStores` ou liste explicite). Sens « depuis le rôle » du dialogue « Assigner des
 * utilisateurs ».
 */
export const replaceRbacRoleAssignments = async ({
  roleId,
  data,
}: {
  roleId: number
  data: ReplaceRbacRoleAssignmentsRequest
}) => {
  const response = await gozokiApiWithAuth.put<RbacRole>(`/rbac/roles/${roleId}/admins`, data)
  return response.data
}

/**
 * Remplacement complet des rôles d'un compte BO, périmètre compris. Sens « depuis la fiche
 * compte » ; gardé côté serveur par `assign-bo-role` sur `users.bo-users.user`.
 */
export const replaceRbacAdminRoleAssignments = async ({
  adminId,
  data,
}: {
  adminId: number
  data: ReplaceRbacAdminRoleAssignmentsRequest
}) => {
  const response = await gozokiApiWithAuth.put(`/rbac/admins/${adminId}/roles`, data)
  return response.data
}
